import React from 'react';

const LinkDeveloper = props => {
  return (<span>- Desenvolvido por <a href="http://www.intuitiveappz.com/" target="_blank" rel="noopener noreferrer">Intuitive Appz | Mobile or Not</a></span>)
};
export default LinkDeveloper;